import { Component, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  NavigationEnd,
  NavigationStart,
  Router,
} from '@angular/router';
import { SportService } from '@app/core';
import { CommonService } from '@app/core/services/common.service';
import { ReplaySubject, Subscription, takeUntil } from 'rxjs';

@Component({
  selector: 'app-sports',
  templateUrl: './sports.component.html',
  styleUrls: ['./sports.component.scss'],
})
export class SportsComponent implements OnInit {
  selectedSport: any;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  constructor(
    public _sport: SportService,
    public _router: Router,
    public _common: CommonService,
    public _activated: ActivatedRoute
  ) { }

  ngOnInit() {
    this._activated.params.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
      this.checkActivation(data['sport']);
    });
    this._router.events.pipe(takeUntil(this.destroyed$)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.checkActivation(this._activated.snapshot.params['sport'] || '');
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  checkActivation(sport: string) {
    let allAllowed: any = this._router.url.split('?');
    allAllowed = allAllowed[0].split('/').pop() || '';
    this.selectedSport =
      sport ||
      (this._sport.includeAllPages.includes(allAllowed)
        ? ''
        : this._sport.defaultSport?.toLowerCase());
  }
}
